<template>
    <div class="swiper-container">
        <div class="swiper know-your-tyres-carousel">
            <div class="swiper-wrapper">
                <div v-for="article in knowYourTyres" :key="article.displayText"
                     class="swiper-slide">
                    <a target="_top" :href="article.link.url">
                        <span class="article-collection-name">
                            <span>
                                {{article.title}}
                                <span class="chevron-right-icon">{{article.link.text}}</span>
                            </span>
                        </span>
                        <img :src="getImageUrl(article.image.urls[0])" alt="" />
                    </a>
                </div>
            </div>
        </div>
        <div class="swiper-button-next swiper-navigation-yellow"></div>
        <div class="swiper-button-prev swiper-navigation-yellow"></div>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import Swiper from 'swiper';
    import SwiperCore, { Navigation } from 'swiper/core';
    SwiperCore.use([Navigation]);

    export default {
        data() {
            return {
                swiper: null,
                knowYourTyres: [],
                cmsBaseUrl: process.env.VUE_APP_CMS_BASE_URL,
            }
        },
        computed: {
            getKnowYourTyres() {
                return this.blockCollection[0].blocks.contentItems;
            },
        },
        watch: {
            blockCollection: {
                handler() {
                    this.knowYourTyres = this.getKnowYourTyres;
                    this.$nextTick(() => {
                        this.reinnitSwiper();
                    })
                }
            }
        },
        mounted() {
            this.swiper = new Swiper(".know-your-tyres-carousel", {
                slidesPerView: "auto",
                spaceBetween: 15,
                navigation: {
                    nextEl: "#HomeKnowYourTyres .swiper-button-next",
                    prevEl: "#HomeKnowYourTyres .swiper-button-prev",
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                    }
                }
            });
        },
        apollo: {
            blockCollection: {
                query: gql`
                    {
                      blockCollection(where: {displayText: "Know Your Tyres"}) {
                        blocks {
                          contentItems(first: 10) {
                            ... on BlockSingle {
                              title
                              image {
                                urls
                              }
                              link {
                                text
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                `,
            }
        },
        methods: {
            reinnitSwiper() {
                this.swiper.update();
            },
            getBaseUrl() {
                var IS_STAG = window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1;
                if (IS_STAG) this.cmsBaseUrl = 'https://dunloptyres-oc-qa.azurewebsites.net';

                return this.cmsBaseUrl;
            },
            getImageUrl(imagePath) {
                var fullPath = this.getBaseUrl() + imagePath;
                return fullPath;
            }
        }
    };
</script>